<template>
    <div>
        <vx-card class="mb-4">
            <div class="w-full flex flex-no-wrap">
                <div class="w-1/2">
                    <h5 class="mb-4">Account Verification</h5>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                            Company Legal Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-company-legal-name"
                                    type="text"
                                    placeholder="Company Legal Name"
                                    v-model="merchantInfo.name"
                                    class="w-full mb-4 no-icon-border"
                                    name="company legal name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('company legal name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Company Type
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-select
                                    id="cbo-company-type"
                                    label-placeholder="Company Type"
                                    placeholder="Select company type"
                                    name="company type"
                                    v-validate="'required'"
                                    class="w-full mb-4 no-icon-border"
                                    v-model="merchantInfo.merchantCategoryID">
                                <vs-select-item
                                        v-bind:id="'cbo-company-type-list'+item.id"
                                        :key="index"
                                        :value="item.id"
                                        :text="item.name"
                                        v-for="(item,index) in companyCategories"/>
                            </vs-select>
                            <span class="text-danger text-sm" v-show="errors.has('merchantCategoryID')">{{ errors.first('company type') }}</span>

                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Brand Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-brand-name"
                                    type="text"
                                    placeholder="brand Name"
                                    v-model="merchantInfo.brandName"
                                    class="w-full mb-4 no-icon-border"
                                    name="brand name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('brand name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full mb-5">
                        <div class="table-cell w-2/5 p-4">
                        Business Entity ID
                        <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                            type="text"
                            placeholder="Business Entity ID"
                            v-model="merchantInfo.business_entity_id"
                            class="w-full mb-4 no-icon-border"
                            name="business_entity_id"
                            />
                            <span class="text-danger text-sm"></span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Email Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-email-address"
                                    type="text"
                                    placeholder="Emaill Address"
                                    v-model="merchantInfo.email"
                                    class="w-full mb-4 no-icon-border"
                                    name="email address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('email address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Address
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-address"
                                    type="text"
                                    placeholder="Address"
                                    v-model="merchantInfo.address"
                                    class="w-full mb-4 no-icon-border"
                                    name="address"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('address') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-w-2/5 p-4">Web Address</div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-web-address"
                                    type="text"
                                    placeholder="Address"
                                    v-model="merchantInfo.webAddress"
                                    class="w-full mb-4 no-icon-border"
                            />
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Name
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-director-name"
                                    type="text"
                                    placeholder="Director's Name"
                                    v-model="merchantInfo.directorName"
                                    class="w-full mb-4 no-icon-border"
                                    name="director name"
                                    v-validate="'required'"
                                    data-vv-validate-on="blur"
                            />
                            <span class="text-danger text-sm">{{ errors.first('director name') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Phone Number
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-phone-number"
                                    type="text"
                                    v-validate="'required|numeric|min:6|max:13'"
                                    name="phone number"
                                    placeholder="Phone Number"
                                    v-model="merchantInfo.phoneNumber"
                                    class="w-full mb-4 no-icon-border"/>
                            <span class="text-danger text-sm">{{ errors.first('phone number') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Director's Identity
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <div class="flex flex-no-wrap">
                                <vs-select
                                        id="cbo-director-identity"
                                        placeholder="Type"
                                        v-model="merchantInfo.directorIdentityType"
                                        class="w-2/5 mb-4 no-icon-border">
                                    <vs-select-item
                                            v-bind:id="'cbo-director-identity-list'+item.id"
                                            :key="index"
                                            :value="item.id"
                                            :text="item.name"
                                            v-for="(item,index) in identityTypes"/>
                                </vs-select>
                                <vs-input
                                        v-if="merchantInfo.directorIdentityType === 1"
                                        id="txt-identity-number-1"
                                        type="text"
                                        placeholder="Identity Number"
                                        v-model="merchantInfo.directorIdentityNumber"
                                        class="w-full ml-1 mb-4 no-icon-border"
                                        name="identity number"
                                        v-validate="'required|numeric'"
                                        data-vv-validate-on="blur"/>
                                <vs-input
                                        v-if="merchantInfo.directorIdentityType !== 1"
                                        id="txt-identity-number-2"
                                        type="text"
                                        placeholder="Identity Number"
                                        v-model="merchantInfo.directorIdentityNumber"
                                        class="w-full ml-1 mb-4 no-icon-border"
                                        name="identity number"
                                        v-validate="'required'"
                                        data-vv-validate-on="blur"/>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <div class="w-2/5 mb-4"></div>
                                <div class="w-full mb-4">
                                    <span class="text-danger text-sm">{{ errors.first('identity-type')||errors.first('identity number') }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Password
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-password"
                                    ref="password"
                                    type="password"
                                    data-vv-validate-on="blur"
                                    v-validate="'required|min:8|verify_password'"
                                    name="password"
                                    placeholder="Create Password"
                                    v-model="merchantInfo.password"
                                    class="w-full mb-4 no-icon-border"/>
                            <span class="text-danger text-sm">{{ errors.first('password') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Confirm Password
                            <span class="text-danger">*</span>
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <vs-input
                                    id="txt-confirm-password"
                                    type="password"
                                    v-validate="'min:8|confirmed:password'"
                                    data-vv-validate-on="blur"
                                    data-vv-as="password"
                                    name="confirm password"
                                    placeholder="Confirm Password"
                                    v-model="merchantInfo.confirmPassword"
                                    class="w-full mb-4 no-icon-border"/>
                            <span class="text-danger text-sm">{{ errors.first('confirm password') }}</span>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Are your business apply work shift ?
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <ul class="demo-alignment">
                                <li>
                                    <vs-radio id="rdo-shift-yes" v-model="merchantInfo.config.has_shift" vs-value="ya" >yes</vs-radio>
                                </li>
                                <li>
                                    <vs-radio id="rdo-shift-no" v-model="merchantInfo.config.has_shift" vs-value="tidak" >no</vs-radio>
                                </li>

                            </ul>
                        </div>
                    </div>
                    <div class="table-row w-full">
                        <div class="table-cell w-2/5 p-4">
                            Merchant has consolidation file?
                        </div>
                        <div class="table-cell w-3/5 p-4">
                            <ul class="demo-alignment">
                                <li>
                                    <vs-radio id="rdo-has-fk-yes" v-model="merchantHasFk" vs-value="yesfk" >yes</vs-radio>
                                </li>
                                <li>
                                    <vs-radio id="rdo-has-fk-no" v-model="merchantHasFk" vs-value="nofk" >no</vs-radio>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <!-- <div v-if="showMerchantConsolidationConfigs"> -->
                        <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                            <div class="table-cell w-2/5 p-4">
                                Max time sending consolidation file
                            </div>
                            <div class="table-cell w-3/5 p-4">
                                <flat-pickr :config="configConsolidationProcessTime" v-model="consolidationProcessTime" placeholder="Max time"/>
                            </div>
                        </div>
                        <div class="table-row w-full" v-if="showMerchantConsolidationConfigs">
                            <div class="table-cell w-2/5 p-4">
                                Consolidation emails notification
                            </div>
                            <div class="table-cell w-3/5 p-4">
                                <div class="flex flex-no-wrap">
                                    <vs-input 
                                        type="text" 
                                        v-model="consolidationEmailTemp" 
                                        placeholder="Email notification" 
                                        class="w-full mb-4 no-icon-border"
                                        maxLength=50 
                                    />
                                    <vs-button
                                        id="btn-add-consolidation-email"
                                        style="margin-left: 5px;"
                                        class="w-1/5 mb-4"
                                        icon-pack="feather"
                                        icon="icon-plus"
                                        @click="addConsolidationEmail"
                                    ></vs-button>
                                </div>
                            </div>
                        </div>
                        <div class="table-row w-full" v-if="showMerchantConsolidationConfigs === true && merchantConsolidationEmails.length > 0">
                            <div class="table-cell w-2/5 px-3">
                               &nbsp;
                            </div>
                            <div class="table-cell w-3/5 px-3">
                                <div class="px-4 py-2"><h5 style="font-weight:700;color:#636363;">Email added</h5></div>
                                <div class="w-full flex flex-wrap" :key="ind" v-for="(data, ind) in merchantConsolidationEmails">
                                    <div class="w-full px-2 py-2 flex flex-wrap">
                                        <div class="w-4/5 px-3 py-2" style="word-break: break-word;">{{data}}</div>
                                        <div class="w-1/5 py-2" style="text-align: center;">
                                            <feather-icon
                                                icon="Trash2Icon"
                                                svgClasses="h-5 w-5"
                                                class="cursor-hand"
                                                @click="deleteConsolidationEmail(ind)"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <!-- </div> -->
                </div>
                <div class="hidden sm:hidden md:hidden lg:block lg:w-1/2 mx-auto self-center">
                    <img class="w-1/2 mx-auto" src="@/assets/images/pages/graphic-4.png" alt="login"/>
                </div>
            </div>

            <div class="w-full">
                <div class="w-1/2">
                    <div class="flex flex-wrap w-full mb-5">
                        <div class="w-2/5 p-4">Legality Documents</div>
                        <div class="w-3/5 flex flex-wrap">
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        id="fil-company-deed"
                                        title="Company Deed"
                                        :file-name="documents[0].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[0].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button id="btn-company-deed" class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true" :href="downloadUrl+documents[0].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        id="fil-business-registration"
                                        title="Business Registration"
                                        :file-name="documents[1].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[1].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button id="btn-business-registration" class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true" :href="downloadUrl+documents[1].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        id="fil-company-registration"
                                        title="Company Registration"
                                        :file-name="documents[2].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[2].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button id="btn-company-registration" class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true" :href="downloadUrl+documents[2].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                            <div class="w-full flex flex-no-wrap">
                                <custom-upload
                                        id="fil-director-identity-document"
                                        title="Director’s Identity Document"
                                        :file-name="documents[3].file_name"
                                        :on-change-callback="handleFileUpload"
                                        :on-delete-callback="handleDelete"/>
                                <div class="self-center m-right-download" v-if="documents[3].url">
                                    <vx-tooltip text="Download" position="top">
                                        <vs-button id="btn-director-identity-document" class="mb-4 md:mb-0" icon-pack="feather"
                                                   icon="icon-download" :target="true" :href="downloadUrl+documents[3].url"></vs-button>
                                    </vx-tooltip>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-1/2 text-right">
                <span class="text-danger">* required field</span>
            </div>
        </vx-card>
        <vx-card>
            <div class="w-full text-right">
                <vs-button id="btn-cancel" type="border" @click="cancelAction">Cancel</vs-button>
                <vs-button id="btn-submit" class="ml-4" @click="submitRequest">Submit</vs-button>
            </div>
        </vx-card>
    </div>
</template>

<script>
    import { url } from '@/configs/apiUrl'
    import MerchantAPI from "@/network/api/MerchantAPI";
    import CustomUpload from "@/components/upload/custom-upload";
    import FileAPI from "@/network/api/FileAPI";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';

    export default {
        components: {CustomUpload,flatPickr,},
        data() {
            return {
                downloadUrl: url.content_delivery_url,
                merchantInfo: {
                    id: '',
                    name: "",
                    business_entity_id:"",
                    brandName: "",
                    email: "",
                    address: "",
                    webAddress: "",
                    directorName: "",
                    directorIdentityType: "",
                    directorIdentityNumber: "",
                    password: "",
                    confirmPassword: "",
                    phoneNumber: "",
                    merchantCategoryID: "",
                    config:{has_shift:"tidak"}
                },
                companyCategories: [],
                merchantCredential: {
                    midAino: ''
                },
                identityTypes: [
                    {
                        id: 1,
                        name: "KTP"
                    },
                    {
                        id: 2,
                        name: "Passport"
                    }
                ],
                documents: [
                    {
                        name: "Company Deed",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Business Registration",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Company Registration",
                        file_name: "",
                        url: ""
                    },
                    {
                        name: "Director’s Identity Document",
                        file_name: "",
                        url: ""
                    }
                ],
                merchantHasFk: "nofk",
                showMerchantConsolidationConfigs: false,
                configConsolidationProcessTime: {
                    noCalendar: true,
                    enableTime: true,
                    enableSeconds: true,
                    dateFormat: 'H:i:S',
                    time_24hr: true,
                },
                consolidationProcessTime: null,
                consolidationEmailTemp: "",
                merchantConsolidationEmails: [],
            }
        },
        computed: {
            validateForm() {
                return (
                    !this.errors.any() &&
                    this.merchantInfo.name != "" &&
                    this.merchantInfo.brandName != "" &&
                    this.merchantInfo.email != "" &&
                    this.merchantInfo.address != "" &&
                    this.merchantInfo.directorName != "" &&
                    this.merchantInfo.directorIdentityType != "" &&
                    this.merchantInfo.directorIdentityNumber != "" &&
                    this.merchantInfo.merchantCategoryID !== "" &&
                    this.merchantInfo.password !== "" &&
                    this.merchantInfo.confirmPassword !== ""
                );
            }
        },
        methods: {
            handleFileUpload(file, title) {
                let payload = {
                    file: file
                }

                FileAPI.Upload(payload).then((result) => {
                    if (title === this.documents[0].name) {
                        this.documents[0].file_name = file.name
                        this.documents[0].url = result.data.url
                    } else if (title === this.documents[1].name) {
                        this.documents[1].file_name = file.name
                        this.documents[1].url = result.data.url
                    } else if (title === this.documents[2].name) {
                        this.documents[2].file_name = file.name
                        this.documents[2].url = result.data.url
                    } else if (title === this.documents[3].name) {
                        this.documents[3].file_name = file.name
                        this.documents[3].url = result.data.url
                    }

                    console.log(this.documents)
                })
            },
            handleDelete(file, title) {
                if (title === this.documents[0].name) {
                    this.documents[0].file_name = ""
                    this.documents[0].url = ""
                } else if (title === this.documents[1].name) {
                    this.documents[1].file_name = ""
                    this.documents[1].url = ""
                } else if (title === this.documents[2].name) {
                    this.documents[2].file_name = ""
                    this.documents[2].url = ""
                } else if (title === this.documents[3].name) {
                    this.documents[3].file_name = ""
                    this.documents[3].url = ""
                }
            },
            cancelAction() {
                this.$router.push({name:'merchantManagement'});
            },
            submitRequest() {
                if (!this.validateForm) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input all required fields!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                if (this.merchantHasFk === "yesfk" && this.consolidationProcessTime === null) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input consolidation process time field!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                if (this.merchantHasFk === "yesfk" && this.merchantConsolidationEmails.length <= 0) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Please input consolidation emails field!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false;
                }

                let config = {}
                config.has_shift = (this.merchantInfo.config.has_shift === "ya") ? true : false
                config.merchant_has_fk  = (this.merchantHasFk === "yesfk") ? true : false
                config.consolidation_process_time = (this.merchantHasFk === "yesfk") ? this.consolidationProcessTime : ""
                config.merchant_consolidation_emails = (this.merchantHasFk === "yesfk") ? this.merchantConsolidationEmails : []

                let payload = {
                    merchantInfo: {
                        full_name: this.merchantInfo.name,
                        brand_name: this.merchantInfo.brandName,
                        business_entity_id: this.merchantInfo.business_entity_id,
                        email: this.merchantInfo.email,
                        url: this.merchantInfo.webAddress,
                        status: "pending",
                        password: this.merchantInfo.password,
                        phone: this.merchantInfo.phoneNumber,
                        category_id: this.merchantInfo.merchantCategoryID,
                        details: {
                            address: this.merchantInfo.address,
                            director_name: this.merchantInfo.directorName,
                            director_identity_number: this.merchantInfo.directorIdentityNumber,
                            director_identity_type: this.merchantInfo.directorIdentityType,
                            documents: this.documents
                        },
                        config:config,
                        user_action: JSON.parse(localStorage.getItem('userInfo')).displayName
                    },
                    notify: this.$vs.notify
                }
                MerchantAPI.Save(payload).then(() => {
                    payload.merchantInfo.password = "******"
                    this.$store.dispatch('createAuditTrail', {
                        user_id:    JSON.parse(localStorage.getItem('userInfo')).id,
                        session_id: parseInt(localStorage.getItem('sessID')),
                        user_name:  JSON.parse(localStorage.getItem('userInfo')).displayName,
                        menu:      "Merchant Management",
                        activity: "Add Merchant",
                        data_before: {},
                        data_after: payload,
                    })
                    this.$vs.notify({
                        title: "Info",
                        text: "Add Merchant succesfuly!",
                        iconPack: "feather",
                        icon: "icon-check-square",
                        color: "success",
                        position: "top-right"
                    });

                    this.$router.push({name:'merchantManagement'});
                })
            },
            addConsolidationEmail() {
                if (this.consolidationEmailTemp.length === 0) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Consolidation email must be fill!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                let regexEmail = /\S+@\S+\.\S+/;
                if (!regexEmail.test(this.consolidationEmailTemp)) {
                    this.$vs.notify({
                        title: "Warning",
                        text: "Email format not valid!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                if (this.merchantConsolidationEmails.includes(this.consolidationEmailTemp)){
                    this.$vs.notify({
                        title: "Warning",
                        text: "Consolidation email already exist, please insert other email!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                if (this.merchantConsolidationEmails.length >= 5) {
                     this.$vs.notify({
                        title: "Warning",
                        text: "Max 5 consolidation emails!",
                        iconPack: "feather",
                        icon: "icon-alert-circle",
                        color: "warning",
                        position: "top-right"
                    });
                    return false
                }
                this.merchantConsolidationEmails.push(this.consolidationEmailTemp)
                this.consolidationEmailTemp = ""
            },
            deleteConsolidationEmail(index) {
                this.merchantConsolidationEmails.splice(index, 1)
            },
        },
        watch: {
            merchantHasFk: function(val) {
                if (val === "yesfk") {
                    this.showMerchantConsolidationConfigs = true
                } else {
                    this.showMerchantConsolidationConfigs = false
                }
            }
        },
        mounted() {
            MerchantAPI.ListMerchantCategoryOptions().then((result) => {
                this.companyCategories = result.data
            })
        }
    }
</script>

<style lang="scss">
    .m-right-download {
        margin-right: -39px;
    }
    .flatpickr-input {
        padding: .7rem;
        font-size: 1rem;
        border-radius: 5px;
        border: 1px solid rgba(0, 0, 0, 0.2);
        color: #626262;
        width: 100%;
    }
</style>



